import { ApiProjectDeviationSummary } from "avvir";

import { AvvirEvent } from "type_aliases";

export type ProjectDeviationSummaryLoadedEvent = AvvirEvent<typeof PROJECT_DEVIATION_SUMMARY_LOADED, {
  projectId: string,
  summary: ApiProjectDeviationSummary
}>

const projectDeviationSummaryLoaded = (projectId: string, summary: ApiProjectDeviationSummary): ProjectDeviationSummaryLoadedEvent => ({
  type: PROJECT_DEVIATION_SUMMARY_LOADED,
  payload: {
    projectId,
    summary
  }
});

export const PROJECT_DEVIATION_SUMMARY_LOADED = "project_deviation_summary_loaded";

export default projectDeviationSummaryLoaded;
